/** @format */


import Vue from 'vue'
import VueMoment from 'vue-moment'
import _ from 'lodash'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiService from './common/api.services'
import { CHECK_AUTH } from '@/store/actions.type'
import localStorageServices from '@/common/jwt.services'
import VueAxios from 'vue-axios'
import FBSignInButton from 'vue-facebook-signin-button'
import GSignInButton from 'vue-google-signin-button'
import SocialSharing from 'vue-social-sharing'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import vPlayBack from 'v-playback'
import moment from 'moment-timezone'
import * as VueGoogleMaps from 'vue2-google-maps'
import Paginate from 'vuejs-paginate'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import VueQrcodeReader from 'vue-qrcode-reader'
import VueHtmlToPaper from 'vue-html-to-paper'
import vueHeadful from 'vue-headful'
import device from "vue-device-detector"
import VuePluralize from 'vue-pluralize'
import VueTelInput from 'vue-tel-input';
import VueGoodTable from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';
import 'vue-tel-input/dist/vue-tel-input.css';
import './registerServiceWorker'
// import './common/session-protection.service'
import 'slick-carousel/slick/slick.css'
import './assets/scss/main.scss'
import vuelidate from 'vuelidate'

import VueLazyload from 'vue-lazyload'
import Fragment from 'vue-fragment'
Vue.use(Fragment.Plugin)

ApiService.init()

Vue.use(VueLazyload, {
  observer: true,
  lazyComponent: true,
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.25
  }
})
Vue.use(device)
Vue.use(VueMoment, { moment })
Vue.use(VueAxios, axios)
Vue.use(VeeValidate)
Vue.use(vuelidate)
Vue.use(VuePluralize)
Vue.use(VueTelInput);
Vue.use(VueGoodTable)


// VeeValidate.Validator.extend('verify_password', {
//   getMessage: field => 
//     `The ${field} must contain at least 6 characters.`,
//   validate: value => {
//     var regex = new RegExp('^(?=.{6,})');
//     return regex.test(value);
//   }
// });

const options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '../public/css/print.css'
  ]
}

Vue.use(DatePicker)
Vue.use(FBSignInButton)
Vue.use(GSignInButton)
Vue.use(SocialSharing)
Vue.use(vPlayBack)
Vue.use(VueQrcodeReader)
Vue.use(VueHtmlToPaper, options)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB6j0khhyp1ob5i6tG6w2MhBzUQQ4HshJc',//'AIzaSyBXWeQ_dVdzGhlJdmyNomLbFTA-PJQoWoM',
    libraries: 'places'
  }
})

Vue.component('vue-headful', vueHeadful)
Vue.component('paginate', Paginate)
Vue.component(VueQrcode.name, VueQrcode)

window.fbAsyncInit = function() {
  FB.init({
    appId: '2301590446738914',
    cookie: true, // enable cookies to allow the server to access the session
    xfbml: true, // parse social plugins on this page
    version: 'v2.8' // use graph api version 2.8
  })
}
;(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0]
  if (d.getElementById(id)) return
  js = d.createElement(s)
  js.id = id
  js.src = '//connect.facebook.net/en_US/sdk.js'
  fjs.parentNode.insertBefore(js, fjs)
})(document, 'script', 'facebook-jssdk')

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    localStorageServices.setObject('previousLocation', from.path)
  }
  if (to.name === 'Register') {
    localStorageServices.setObject('previousLocation', from.path)
  }
  return Promise.all([store.dispatch(CHECK_AUTH)]).then(next)
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.$ = require('jquery')
window.JQuery = require('jquery')
